import { useState, useRef, useEffect } from "react";
import "./chatbot.css";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";

function ChatBot() {

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [userLatitude, setUserLatitude] = useState(null);
    const [userLongitude, setUserLongitude] = useState(null);
    const navigate = useNavigate();

    const [messages, setMessages] = useState([
        {
            sender: "bot",
            text: "👋 Hello!\n\nI'm the Arboreatrix Assistant.\nAsk me anything about trees, locations, species, planting, or this website."
        }
    ]);

    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({
            behavior: "smooth"
        });
    }, [messages]);

    useEffect(() => {
        if (open) {
            getCurrentLocation();
        }
    }, [open]);

    const getCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by this browser.");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setUserLatitude(position.coords.latitude);
                setUserLongitude(position.coords.longitude);
                console.log("Latitude:", position.coords.latitude);
                console.log("Longitude:", position.coords.longitude);
            },
            (error) => {
                console.error(error);
                alert("Unable to get your location.");
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    const viewOnMap = (tree) => {
        navigate(`/LandingPageMap?treeinstanceid=${tree.treeinstanceid}`);
    };

    const sendMessage = async () => {

        if (message.trim() === "") return;

        const userMessage = message;

        // Show user's message
        setMessages(prev => [
            ...prev,
            {
                sender: "user",
                text: userMessage
            }
        ]);

        setMessage("");
        setIsTyping(true);

        try {

            const response = await fetch(`${API_URL}/chatbot/chatbot.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        message: userMessage,
                        latitude: userLatitude,
                        longitude: userLongitude
                    })
                }
            );

            const result = await response.json();

            if (result.type === "nearest_trees") {

                setMessages(prev => [
                    ...prev,
                    {
                        sender: "bot",
                        type: "nearest_trees",
                        trees: result.trees
                    }
                ]);

                setIsTyping(false);
                return;
            }

            if (result.success) {

                setMessages(prev => [
                    ...prev,
                    {
                        sender: "bot",
                        text: result.reply
                    }
                ]);

                setIsTyping(false);
                return;
            }
            
        } catch (err) {

            console.error(err);

            setMessages(prev => [
                ...prev,
                {
                    sender: "bot",
                    text: "Unable to connect to the PHP server."
                }
            ]);

        }

    };

    return (
        <>

            <div
                className="chatbot-button"
                onClick={() => setOpen(!open)}
            >
                💬
            </div>

            {open && (

                <div className="chat-window">

                    <div className="chat-header">

                        <div>
                            <h4>🌳 Arboreatrix AI</h4>
                            <span>Powered by Groq</span>
                        </div>

                        <button
                            className="close-btn"
                            onClick={() => setOpen(false)}
                        >
                            ✕
                        </button>

                    </div>

                    <div className="chat-body">

                        {messages.map((msg, index) => (

                            <div
                                key={index}
                                className={
                                    msg.sender === "user"
                                        ? "user-message"
                                        : "bot-message"
                                }
                            >
                                {msg.type === "nearest_trees" ? (
                                    msg.trees.map((tree, i) => (
                                        <div key={i} className="nearest-tree-card">
                                            <h4>{tree.name}</h4>
                                            <p>
                                                <strong>Latitude:</strong> {tree.latitude}
                                            </p>
                                            <p>
                                                <strong>Longitude:</strong> {tree.longitude}
                                            </p>
                                            <button
                                                className="map-btn"
                                                onClick={() => viewOnMap(tree)}
                                            >
                                                📍 View on Map
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    msg.text
                                )}
                            </div>
                        ))}

                        {isTyping && (

                            <div className="bot-message typing">

                                <span></span>
                                <span></span>
                                <span></span>

                            </div>

                        )}

                        <div ref={bottomRef}></div>

                    </div>

                    <div className="chat-footer">

                        <input
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    sendMessage();
                                }
                            }}
                            placeholder="Ask something..."
                        />

                        <button onClick={sendMessage}>
                            ➤
                        </button>

                    </div>

                </div>

            )}

        </>
    );

}

export default ChatBot;